import React, {Component} from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class AprobarModal extends Component{
    onSubmit(){
        this.props.action();
        this.props.toggler();
    }
    render(){
        return(
            <Modal className="modal-dialog-centered" isOpen={this.props.show} toggle={this.props.toggler}>
                <ModalHeader toggle={this.props.toggler}>Aprobar caso</ModalHeader>
                <ModalBody>
                    <p>Aprobar el caso significa que acepta expresamente las condiciones del tratamiento, la configuración mostrada en el estudio así como el precio estipulado. El laboratorio iniciará la producción al recibir su notificación, esta orden no podrá deshacerse.</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={this.props.toggler}>Cancelar</Button>
                    <Button color="primary" onClick={this.onSubmit.bind(this)}>Aprobar</Button>{' '}
                </ModalFooter>
            </Modal>

        )
    }
}
export default AprobarModal


// WEBPACK FOOTER //
// ./resources/assets/js/components/viewer/AprobarModal.jsx